import React from 'react';
import RegisterGroupPageBody from '../components/RegisterGroupPageBody';

function RegisterGroupPage() {
    return <RegisterGroupPageBody />;
}

export default RegisterGroupPage;